import { render, staticRenderFns } from "./DashboardIndexComponent.vue?vue&type=template&id=0e1f08b6"
import script from "./DashboardIndexComponent.vue?vue&type=script&lang=js"
export * from "./DashboardIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports